<template>
  <Header />

    <GiftEdit :gift="gift" />

    <Footer />
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import GiftEdit from "@/components/GiftEdit.vue";

export default {
  name: "GiftEditView",
  components: {
    Header,
    Footer,
    GiftEdit,
  },
  created() {
    if (!this.$store.state.giftMap.find(item => item.id === this.$route.params.id)) {
      this.$router.push({ name: 'Gifts' })
    }
  },
  data() {
    return {
      gift: this.$store.state.giftMap.find(item => item.id === this.$route.params.id),
    }
  },
};
</script>
